import * as baseAdapter from './baseAdapter';

export const searchInvoice = async (req: any) => {
  const ret = await baseAdapter.post<any>('/v1/invoice/inquiry', req);
  return ret;
};

export const invoiceEntry = async (req: any) => {
  const ret = await baseAdapter.post<any>(
    '/v1/invoice/service/etaxsigndocument',
    req
  );
  return ret;
};

export const invoiceVerify = async (req: any) => {
  const ret = await baseAdapter.post<any>(
    '/v1/invoice/getdocument/getdocumentstatus',
    req
  );
  return ret;
};

export const getInvoiceLines = async (req: {
  ID: string;
  TYPECODE: string;
}) => {
  const ret = await baseAdapter.post<any>('/v1/invoice/lines', req);
  return ret;
};
